import { Grid } from "antd";

/** true sotto md (768 px): smartphone. Le tabelle diventano schede, le modali vanno a schermo intero. */
export function useIsMobile() {
  const s = Grid.useBreakpoint();
  return s.md === false;
}
